import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PageComponentModule } from '../../../../cms-structure';
import { provideDefaultConfig } from '../../../../core/config';
import { I18nModule } from '../../../../core/i18n';
import { ContainerSizeModule, GenericLinkModule, MediaModule, PipesModule } from '../../../../shared';
import { NewsComponent } from './news.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MediaModule,
    PageComponentModule,
    NzIconModule,
    PipesModule,
    ContainerSizeModule,
    GenericLinkModule,
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        NewsComponent: {
          component: NewsComponent,
        },
      },
    }),
  ],
  declarations: [NewsComponent],
  exports: [NewsComponent],
})
export class CmsNewsModule {}
